import { sleep } from "../../../library-js/animation/sleep";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Property } from "../../../library-js/events/Property";
import { DataMessage } from "../../../library-js/messages/DataMessage";
import { Message } from "../../../library-js/messages/Message";
import { MessageTypes } from "../../../library-js/messages/MessageType";
import { Request } from "../../../library/ts/html/server/Request";
import { UserSystem } from "../../code/library-ts/browser/users/UserSystem";
import { Result } from "../computation-forms/computeAvailableNumberOfTextures";
import { Rokojori } from "../Rokojori";

export class EmailData
{
  email:string;
}

export class EmailPasswordData extends EmailData
{
  password:string;
}

export class TokenData
{
  token:string;
}

export class PageTokenData
{
  pageToken:string;
}

export class LinkUserData extends PageTokenData
{
  userToken:string;
  renewal:string;
}

export class LocationData
{
  country:string;
  city:string;
  km_range:number;
}

export class UserLoginDataInfo
{
  time:string;
  location:LocationData;
  app:string;
  os:string;
  deviceType:string;
}

export class UserData
{
  email:string;
  id:string;
  name:string;
  lastLogins:UserLoginDataInfo[];
}

export class SessionData
{
  token:string;
  renewal:string;
}

export class RokojoriWebsiteUserSystem extends UserSystem
{
  // static productionURL = "https://backend.rokojori.com:1712";
  // static localURL      = "http://192.168.178.51:1712";

  static linkUserURL   = "::/_php/link-user.php";
  static getUserURL   = "::/_php/get-user.php";

  // _loggedIn = false;
  // _userData:UserData;

  // readonly userID = new Property<string>( null );

  // _sessionData:SessionData;

  // get sessionToken(){ return this._sessionData?.token || null };

  // get isLoggedIn()
  // {
  //   return this._loggedIn; 
  // }

  // get userName()
  // {
  //   return this._userData?.name || null;
  // }

  // get url()
  // {
  //   return Rokojori.$.isLocal ? UserSystem.localURL : UserSystem.productionURL;
  // }

  // protected _apps:UserApps;
  // get apps(){ return this._apps }
  
  // constructor()
  // {
  //   this._apps = new UserApps( this );

  // }

  async applyOnDocument()
  {
    let relativeLinkURL = Rokojori.$.pathConverter.rootToRelative( RokojoriWebsiteUserSystem.getUserURL );

    let pageToken = Rokojori.$.token;

    
    let userSessionData = await Request.post<PageTokenData,DataMessage<SessionData>>( relativeLinkURL, { pageToken } );
    
    console.log( { pageToken, userSessionToken: userSessionData } );

    this._loggedIn = false;
    this._userData = null;
    this._sessionData = null;

    if ( userSessionData.data )
    {
      this._sessionData = userSessionData.data;
      this._userData = await this.info();

      if ( ! this._userData )
      {
        await this.renew();
      }

      console.log( "Requesting data: ", userSessionData.data, this._userData );

      if ( this._userData )
      {
        this._loggedIn = true;
        this._sessionData = userSessionData.data;
        setTimeout( ()=>{ this.userID.value = this._userData.id }, 100 );
      }      
      else
      {
        this._sessionData = null;
        await this.unlinkUserSession();
      }
    }
  }

  async unlinkUserSession():Promise<void>
  {
    return this._linkUserSession( "", "" );
  }

  async linkUserSession():Promise<void>
  { 
    return this._linkUserSession( this._sessionData.token, this._sessionData.renewal );
  }

  async _linkUserSession( userToken:string, renewalToken:string ):Promise<void>
  {   
    console.log( "linking user:", userToken, renewalToken );  
    let linkedUser = { pageToken: Rokojori.$.token, userToken:userToken, renewal:renewalToken };
    let relativeLinkURL = Rokojori.$.pathConverter.rootToRelative( RokojoriWebsiteUserSystem.linkUserURL );
    let linkResult = await Request.post<LinkUserData,Message>( relativeLinkURL, linkedUser ); 

    console.log( "Link result:", linkResult );
    return Promise.resolve();
  }

  async login( email:string, password:string, debugOutput:string[] = undefined ):Promise<boolean>
  {
    await this.unlinkUserSession();

    let loggedIn = await super.login( email, password, debugOutput );

    if ( loggedIn )
    {
      this.linkUserSession();
    }

    return Promise.resolve( loggedIn );
  }

  async logout():Promise<void>
  {
    await this.unlinkUserSession();
    await super.logout();
  }

  async renew():Promise<void>
  {
    await this.unlinkUserSession();

    await super.renew();

    if ( this._sessionData )
    {
      this.linkUserSession();
    }

  }

}